import { render, staticRenderFns } from "./RunnitBoardsManagement.vue?vue&type=template&id=8406cbf0&scoped=true"
import script from "./RunnitBoardsManagement.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardsManagement.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardsManagement.vue?vue&type=style&index=0&id=8406cbf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8406cbf0",
  null
  
)

export default component.exports